import { FC } from 'react';
import SuperUpload from '../SuperUpload';
import SimpleFormItem from './subpage/simpleFormItem';
import { BaseSimpleFormProps, SimpleFormItemEnum } from './interface';
import { UploadFileProps } from '../SuperUpload/uploadFile';

export interface SimpleFormUploadProps extends BaseSimpleFormProps {
  uploadProps?: UploadFileProps;
}
const simpleFormUpload: FC<SimpleFormUploadProps> = props => {
  const { uploadProps, ...restProps } = props;
  const normFile = (e: any) => {
    if (Array.isArray(e)) {
      return e;
    }
    return e && e.fileList;
  };
  return (
    <SimpleFormItem
      valuePropName="fileList"
      getValueFromEvent={normFile}
      {...restProps}
    >
      <SuperUpload.File {...uploadProps} />
    </SimpleFormItem>
  );
};

simpleFormUpload.displayName = SimpleFormItemEnum.SimpleFormUpload;

export default simpleFormUpload;
